import { Tooltip, PopoverPosition } from "construct-ui";
import ViewBase from "../../view-base.view";
import fixtureModel from '../../../models/planogram/fixture.model';
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import FileUploadInputComponent from "../../../components/file/file-upload-input.component";
import codeMasterModel from "../../../models/common/code-master.model";
import { codeMasterType } from "../../../config/constants";
import loginModel from "../../../models/login.model";


export default function FixtureEditView() {
  ViewBase.call(this);

  let onClose = (e) => { };
  let onSave = (e) => { };

  let planogramDivGroups = [];
  let planogramTypes = [];
  let statuses = [];

  const inputDataModel = {
    planogramFixtureID: '',
    fixtureName: "",
    divGroup: '',
    planogramType: '',
    status: '',
  };

  let _uploadingFile = null;
  let previewUrl = null;

  const getStatuses = () => {
    codeMasterModel.getByCategoryV2({ category: 'CommonStatus' })
      .then((result) => {
        statuses = result
      })
      .catch((error) => {
        this.handleError(error);
      })
  }

  const getPlanogramDivGroups = () => {
    codeMasterModel.getCodemasterCategoryData(loginModel.credentials.country, codeMasterType.planogramDivGroup)
      .then(result => {
        planogramDivGroups = result
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const getPlanogramTypes = () => {
    codeMasterModel.getByCategoryV2({ category: codeMasterType.planogramType })
      .then(result => {
        planogramTypes = result
      })
      .catch(error => {
        this.handleError(error)
      })
  }


  const handleSave = (e) => {
    if (!this.validateForm(e, "#fixtureEdit")) {
      return false;
    } else {
      let filesFormData = new FormData();
      if (_uploadingFile) {

        filesFormData.append("file", _uploadingFile);
      }
      const paramsObj = structuredClone(inputDataModel);

      for (const p in paramsObj) {
        if (p == 'status') {
          paramsObj[p] = Number(paramsObj[p]);
        }
        filesFormData.append(p, paramsObj[p]);
      }
      fixtureModel.updateFixture(filesFormData).then((result) => {
        onSave(result);
      }).catch((error) => {
        this.handleError(error);
      })
    }
  }

  const handleCancel = (e) => {
    onClose(e);
  }

  const selectFile = (file) => {
    if (file) {
      _uploadingFile = file;
      // inputDataModel.fixtureName = file.name.slice(0, file.name.lastIndexOf('.'));
      const reader = new FileReader();
      reader.onload = (e) => {
        previewUrl = e.target.result;
        m.redraw();
      };
      reader.readAsDataURL(file);
    }
  }

  return {
    oninit: (vnode) => {
      getPlanogramDivGroups();
      getStatuses();
      getPlanogramTypes();
      if (vnode.attrs.record) {
        const fixtureData = vnode.attrs.record;
        inputDataModel.planogramFixtureID = fixtureData.planogramFixtureID;
        inputDataModel.fixtureName = fixtureData.fixtureName;
        inputDataModel.divGroup = fixtureData.divGroup;
        inputDataModel.planogramType = fixtureData.planogramType;
        inputDataModel.status = String(fixtureData.status);
      }

      if (vnode.attrs.onClose) {
        onClose = vnode.attrs.onClose;
      }
      if (vnode.attrs.onSave) {
        onSave = vnode.attrs.onSave;
      }

    },
    view: (vnode) => {
      return [
        m("form#fixtureEdit.card-body.needs-validation[novalidate]", { onsubmit: handleSave },
          m(".mt-2.position-relative",
            m('img.img-thumbnail', {
              src: previewUrl ? previewUrl : vnode.attrs.record?.photo, alt: "fixture photo",
              // style: { height: "200px" } 
            }),
            m('.mt-2.position-relative',
              m('label.form-label[for="fixturePhotoInput"]', this.getText("LT00001311", "Image")),
              m(FileUploadInputComponent, {
                id: 'fixturePhotoInput',
                accept: ".jpg, .jpeg, .gif, .png",
                onInput: (file) => selectFile(file),
              })
            ),
          ),

          m('.mt-2.position-relative',
            m('label.form-label.mandatory[for="fixtureNameInput"]', this.getText('LT00001197', 'Image Name'), m(Tooltip, {
              content:
                m('p', m('p', "Please be cautious when modifying the image name."),
                  m('p', "Once the name is changed, all future ", m('strong', "Store Mapping"), " and ", m('strong', "SKU Mapping"), " Excel uploads must use the new image name. If you do not use the updated name, the system will assume the image does not exist and will use the ",m('strong', "default image"),  " instead.")
                ),
              style: { "width": '350px' },
              hoverOpenDelay: 250,
              openOnTriggerFocus: true,
              position: PopoverPosition.RIGHT,
              trigger: m('i.bi.bi-info-circle.cursor-pointer.ps-1.me-0', { style: { 'color': '#FF9800' } })
            })),
            m('input#fixtureNameInput', {
              class: 'form-control form-control-bg',
              placeholder: this.getText('LT00001197', 'Image Name'),
              type: 'text',
              value: inputDataModel.fixtureName,
              onchange: (e) => { inputDataModel.fixtureName = e.target.value }
            })
          ),
          m(".mt-2.position-relative",
            m("label.form-label.mandatory[for='divisionGroup']",
              this.getText("LT00000246", "Division Group")
            ),
            m(SingleSelectComponent, {
              id: "planogramDivGroup",
              items: planogramDivGroups,
              allowEmpty: false,
              selectedItem: planogramDivGroups.find(e => e.code === inputDataModel.divGroup),
              onSelect: (s) => {
                inputDataModel.divGroup = s.code;
              },
            }),
            m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
          ),

          m(".mt-2.position-relative",
            m("label.form-label.mandatory[for='divisionGroup']",
              this.getText('LT00001198', 'Image Type')
            ),
            m(SingleSelectComponent, {
              id: "planogramTypes",
              items: planogramTypes,
              allowEmpty: false,
              selectedItem: planogramTypes.find(e => e.code === inputDataModel.planogramType),
              onSelect: (s) => {
                inputDataModel.planogramType = s.code;
              },
            }),
            m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
          ),
          m('.mt-2.position-relative',
            m('label.form-label.mandatory[for="statusSelect"]', this.getText('LT00000781', 'Status')),
            m(SingleSelectComponent, {
              id: 'statusSelect',
              items: statuses,
              allowEmpty: false,
              selectedItem: statuses.find(e => e.code === inputDataModel.status),
              onSelect: (selectedItem) => {
                inputDataModel.status = selectedItem.code
              }
            })
          ),

          m('.col-md-12.gap-2.mt-4.d-flex.justify-content-end',
            m('button.btn.btn-primary[type="submit"].px-4.gap-3', this.getText('LT00000022', "Save")),
            m(
              "button.btn.btn-white[type='button']", { onclick: handleCancel },
              this.getText("LT00000021", "Close")
            )
          )
        ),
        this.getBaseViews()
      ];
    }
  }
}
